import React, { useState, useEffect, useCallback } from 'react';
import './index.css';

import Slide1 from './pages/Slide1/Slide1';
import Slide2 from './pages/Slide2/Slide2';
import Slide03Video from './pages/Slide3Video/Slide03Video';
import Slide04Offices from './pages/Slide4Offices/Slide04Offices';
import Slide3 from './pages/Slide3/Slide3';
import Slide3Services from './pages/Slide3/Slide3Services';
import Slide05Scope from './pages/Slide5/Slide05Scope';
import Slide06NavCom from './pages/Slide6/Slide06NavCom';
import Slide07NavComStats from './pages/Slide7/Slide07NavComStats';
import Slide08Automation from './pages/Slide8Automation/Slide08Automation';
import Slide09Gallery from './pages/Slide9Gallery/Slide09Gallery';
import SlideOfficesGallery from './pages/SlideOfficesGallery/SlideOfficesGallery';
import Slide10RND from './pages/Slide10RND/Slide10RND';
import SlideRNDGallery from './pages/SlideRNDGallery/SlideRNDGallery';
import Slide11ClassSocieties from './pages/Slide11ClassSocieties/Slide11ClassSocieties';
import Slide12OperationsDocs from './pages/Slide12OperationsDocs/Slide12OperationsDocs';
import Slide13ProjectSales from './pages/Slide13ProjectSales/Slide13ProjectSales';
import Slide14SpareParts from './pages/Slide14SpareParts/Slide14SpareParts';
import Slide15RemoteSupport from './pages/Slide15RemoteSupport/Slide15RemoteSupport';
import Slide16Closing from './pages/Slide16Closing/Slide16Closing';
import Slide08Partners from './pages/Slide8/Slide08Partners';
import Slide08PartnersLast from './pages/Slide8/Slide08PartnersLast';

const SLIDE_COUNT = 22;
const OFFICES_IDX = 3;
// 0,1,2 = kart sayfaları, 3 = dünya haritası → sonra gerçek slayta geç
const OFFICES_STEPS = 5;

function App() {
  const [current, setCurrent] = useState(0);
  const [officesStep, setOfficesStep] = useState(0);

  const goNext = useCallback(() => {
    if (current === OFFICES_IDX && officesStep < OFFICES_STEPS - 1) {
      setOfficesStep((s) => s + 1);
    } else {
      if (current === OFFICES_IDX) setOfficesStep(0);
      setCurrent((prev) => Math.min(prev + 1, SLIDE_COUNT - 1));
    }
  }, [current, officesStep]);

  const goPrev = useCallback(() => {
    if (current === OFFICES_IDX && officesStep > 0) {
      setOfficesStep((s) => s - 1);
    } else {
      if (current === OFFICES_IDX + 1) {
        // Offices slaytına geri dönünce son adımdan başla
        setOfficesStep(OFFICES_STEPS - 1);
      }
      setCurrent((prev) => Math.max(prev - 1, 0));
    }
  }, [current, officesStep]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [goNext, goPrev]);

  const renderSlide = () => {
    switch (current) {
      case 0:  return <Slide1 />;
      case 1:  return <Slide2 />;
      case 2:  return <Slide03Video />;
      case 3:  return <Slide04Offices step={officesStep} />;
      case 4:  return <Slide3 />;
      case 5:  return <Slide3Services />;
      case 6:  return <Slide05Scope />;
      case 7:  return <Slide06NavCom />;
      case 8:  return <Slide07NavComStats />;
      case 9:  return <Slide08Automation />;
      case 10: return <Slide09Gallery />;
      case 11: return <SlideOfficesGallery />;
      case 12: return <Slide10RND />;
      case 13: return <SlideRNDGallery />;
      case 14: return <Slide11ClassSocieties />;
      case 15: return <Slide08Partners />;
      case 16: return <Slide08PartnersLast />;
      case 17: return <Slide12OperationsDocs />;
      case 18: return <Slide13ProjectSales />;
      case 19: return <Slide14SpareParts />;
      case 20: return <Slide15RemoteSupport />;
      case 21: return <Slide16Closing />;
      default: return null;
    }
  };

  return (
    <div className="presentation">
      <div className="slide-container">
        {renderSlide()}
      </div>

      <div className="controls">
        <button onClick={goPrev} disabled={current === 0 && officesStep === 0}>&#8592;</button>
        <span className="slide-counter">{current + 1} / {SLIDE_COUNT}</span>
        <button onClick={goNext} disabled={current === SLIDE_COUNT - 1}>&#8594;</button>
      </div>
    </div>
  );
}

export default App;
